"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = require("./common");

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/numeric.js
// module id = 327
// module chunks = 0